module.exports = __webpack_public_path__ + "img/1.b820ea4.svg";